import { cn } from 'lib/helpers/utility';

const TableCell = ({ children, index, lastIdx, className, bodyClassName, style, colSpan }) => {
  let cellClass = 'w-fit py-[6px] align-top';
  if (index !== 0) cellClass += ' px-2';
  if (index === 0) cellClass += ' pl-1.5';
  if (index === lastIdx) cellClass += ' pr-1.5';

  return (
    <td className={cn(cellClass, className)} colSpan={colSpan} style={style}>
      <div
        className={cn(
          'flex items-start',
          index === lastIdx ? 'justify-end' : 'justify-start',
          bodyClassName
        )}>
        {children}
      </div>
    </td>
  );
};

export default TableCell;
